<template>
  <div class="box" style="text-align:center;">
       <functional-calendar :dayNames="dayNames" :monthNames="monthNames" @input="getInput" ref="calendar" v-if="ishide" :is-separately='false' :isAutoCloseable='true' :is-date-range='true' :is-multiple='true'  v-model="calendarData" @selectedDaysCount="selectedDaysCount"></functional-calendar>
       <div class="btn">
            <span class="left_btn" @click="hideRange">取消</span>
            <span class="left_btn right_btn" @click="confirm">确定</span>
       </div>
  </div>
</template>
<script>
    import { FunctionalCalendar } from 'vue-functional-calendar'
    export default {
        components: {
            FunctionalCalendar
        },
        data () {
            return {
                dayNames: [ '日', ' 一', ' 二', '三', '四', '五', '六' ],
                calendarData: {},
                ishide: true,
                time: '',
                monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
            }
        },
        created () {

        },
        methods: {
            getInput (value) {
                if (value.dateRange.end.date === false && value.dateRange.start.date) {
                    var data1 = value.dateRange.start.date.split('/')
                    this.time = [data1[2] + '-' + data1[1] + '-' + data1[0], data1[2] + '-' + data1[1] + '-' + data1[0], '自定义日期范围']
                } else {
                    if (value.dateRange.end.date) {
                        var endArr = value.dateRange.end.date.split('/')
                        var startArr = value.dateRange.start.date.split('/')
                        this.time = [startArr[2] + '-' + startArr[1] + '-' + startArr[0], endArr[2] + '-' + endArr[1] + '-' + endArr[0], '自定义日期范围']
                    }
                }
            },
            selectedDaysCount (data) {

            },
            hideRange () {
                this.time = ''
                this.$emit('closeRangTime', this.time)
            },
            confirm () {
                this.$emit('closeRangTime', this.time)
            }
        }
    }
</script>
<style scoped lang="less">
   .box{
       position:fixed;
       width:100%;
       height:100%;
       left:0;
       top:0;
       background: rgba(0,0,0,.4);
       z-index:20;
       .btn{
           width:90%;
           height:60px;
           display: inline-block;
           background: #fff;
           box-shadow: 0 0.053333rem 0rem 0 rgba(0,0,0,0.25);
           border-radius: 0 0 8px 8px;

           .left_btn{
               display: inline-block;
               width:90px;
               height:40px;
               background-color: #ccc;
               text-align: center;
               line-height: 40px;
               border-radius: 8px;
               color:#fff;
               font-size:14px;
               margin-right:20px;
           }
           .right_btn{
               background-color: #36B374;
               margin-left:20px;
               margin-right:0;
           }
       }
   }
</style>
<style>
.vfc-main-container{
    width:90%!important;
    display: inline-block;
    margin-top:140px;
    /* left:50%;
    top:50%;
    transform: translate(-50%,-50%) */
}
.vfc-styles-conditional-class .vfc-main-container{
    border-radius: 8px 8px 0 0!important;
    box-shadow: none!important;
    -webkit-box-shadow:none!important;
}
.vfc-styles-conditional-class .vfc-main-container .vfc-calendars-container .vfc-calendars .vfc-calendar div.vfc-content .vfc-week div.vfc-day span.vfc-span-day.vfc-today{
    background-color: #36B374!important;

}
.vfc-styles-conditional-class .vfc-main-container .vfc-calendars-container .vfc-calendars .vfc-calendar div.vfc-content .vfc-week div.vfc-day span.vfc-span-day.vfc-hover:hover{
    background-color: #36B374!important;
}
.vfc-styles-conditional-class .vfc-main-container .vfc-calendars-container .vfc-calendars .vfc-calendar div.vfc-content .vfc-week div.vfc-day span.vfc-span-day.vfc-hover:hover{
    background-color: #36B374!important;
}
.vfc-styles-conditional-class .vfc-main-container .vfc-calendars-container .vfc-calendars .vfc-calendar div.vfc-content .vfc-week div.vfc-day span.vfc-span-day.vfc-marked{
    background-color: #36B374!important;
}
.vfc-styles-conditional-class .vfc-main-container .vfc-calendars-container .vfc-calendars .vfc-calendar div.vfc-content .vfc-week div.vfc-day span.vfc-span-day.vfc-marked:before{
    background-color: #36B374!important;
}
</style>
